<template>
  <span style="padding-left: 20px">
    <a-button type="primary" @click="searchEvent()" :size="size">查询</a-button>
     <a-button v-if="showResetButton" style="margin-left: 8px" @click="resetEvent()" :size="size">重置</a-button>
    <a-button v-if="exportType > 0" style="margin-left: 5px;" :size="size">
      <a-dropdown v-if="exportType === 1 && menuList && menuList.length > 0">
        <a class="ant-dropdown-link">批量导出<a-icon type="down"/> </a>
        <a-menu slot="overlay" @click="e => onExportEvent(e)">
          <a-menu-item v-for="(item, index) in menuList" :key="index">
            <a href="javascript:">{{ itemKey ? item[itemKey] : item }}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <a v-else @click="onClickExport">批量导出</a>
    </a-button>
    <slot></slot>
    <a v-if="showAdvanced" @click="toggleAdvanced" style="margin-left: 5px">
      {{ unfoldState ? '收起' : '展开' }}
      <a-icon :type="unfoldState ? 'up' : 'down'"/>
    </a>
  </span>
</template>

<script>
export default {
  name: 'SearchCombinationButton',
  props: {
    showAdvanced: {
      type: Boolean,
      default: false
    },
    showResetButton: {
      type: Boolean,
      default: false
    },
    //导出类型  1、是菜单类型  2是按钮类型
    exportType: {
      type: Number,
      default: 0
    },
    unfoldState: {
      type: Boolean,
      default: false
    },
    //（导出）菜单列表
    menuList: {
      type: Array,
      default: () => ['CSV', 'Excel']
    },
    //菜单数据关键字（当列表数据不是字符串或者数字时，才传）
    itemKey: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    searchEvent() {
      this.$emit('search')
    },
    toggleAdvanced() {
      this.$emit('change', !this.unfoldState)
    },
    resetEvent() {
      this.$emit('reset')
    },
    onExportEvent(e) {
      this.$emit('export')
    },
    onClickExport() {
      this.$emit('export')
    }
  }
}
</script>
<style scoped>
</style>